/// <reference path='../../_references.ts' />
module onvio.setup.billingComponentTestPage {
    'use strict';

    angular.module('onvio.setup.billingComponentTestPage', ['bm.practice.billing.component.BillingComponentDirective', 'csPartialInvoiceV1'])
        // THIS IS FOR TESTING ONLY. MOVE THIS TO NUCLEUS-STAFF
        .config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
            // Casting IState to any because we are using Angular injection on the function, which makes TypeScript unable to recognize it as a function.
            $stateProvider.state('billing-component', <any>{
                url: '/billing-component?projectScheduleItemId',
                template: 'NOTE: These controls are for testing purposes only. ' +
                'Project and Bill Total are required for the component to start functioning.<br>' +
                '<div ng-if="!vm.hideProject">' +
                'Client: <bmp-select-combo list="clients#active"' +
                '   name="client" ng-model="vm.client">' +
                '</bmp-select-combo>' +
                'Project: <bmp-select-combo list="projects"' +
                '   name="projectScheduleItem" ng-model="vm.projectScheduleItem"' +
                '   filter="vm.projectComboFilter()">' +
                '</bmp-select-combo></div>' +
                'Bill Total: <input type="text" ng-model="vm.definition.billTotal"></input>' +
                '<input type="checkbox" ng-model="vm.definition.hideOverrideTotal">Hide Override total</input>' +
                '<input type="checkbox" ng-model="vm.definition.hideDiscount">Hide Discount</input><br>' +
                '<button type="button" class="btn" data-ng-click="vm.refresh()">Reload</button>' +
                '<span busy-loader="vm.printingBill"><button type="button" class="btn" data-ng-click="vm.printBill()">Print bill</button></span><hr>' +
                '<bm-practice-billing-component ng-if="vm.visible" bm-practice-billing-component-definition=vm.definition>' +
                '</bm-practice-billing-component>',
                controller: ['$stateParams', '$timeout', 'csPartialInvoiceV1',
                    function($stateParams: ng.ui.IStateParamsService, $timeout: ng.ITimeoutService, csPartialInvoice: cs.IPartialInvoiceV1Service) {
                        this.visible = true;
                        this.printingBill = false;
                        var stateParamId = $stateParams['projectScheduleItemId'];
                        this.hideProject = stateParamId;
                        this.definition = { projectScheduleItemId: stateParamId, billTotal: '' };
                        this.projectComboFilter = () => {
                            if (this.client) {
                                return new bmp.Filter().where('client.id').equals(this.client.id);
                            }
                            return null;
                        };
                        var updateProjectScheduleItem = () => {
                            if (!this.hideProject) {
                                this.definition.projectScheduleItemId = this.projectScheduleItem ? this.projectScheduleItem.id : '';
                            }
                        };
                        this.refresh = () => {
                            this.visible = false;
                            updateProjectScheduleItem();
                            $timeout(() => {
                                this.visible = true;
                            }, 100);
                        };
                        this.printBill = () => {
                            updateProjectScheduleItem();
                            this.printingBill = true;
                            csPartialInvoice.post({ data: {
                                projectScheduleItemId: this.definition.projectScheduleItemId,
                                billTotal: this.definition.billTotal
                            }}).then((result) => {// TODO - ng161 - handle reject
                                return csPartialInvoice.postInvoiceByPartialInvoice({ data: result });
                            }).finally(() => {
                                this.printingBill = false;
                            });
                        };
                    }],
                controllerAs: 'vm',
                reloadOnSearch: false,
                resolve: {
                    'resolve.translationsLoaded': [
                        '$translate', ($translate: ng.translate.ITranslateService) => {
                            return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
                        }
                    ],
                    'resolve.featureToggle': [
                        'bmpFeatureToggles', (featureToggles: bmp.IFeatureTogglesService) => {
                            return featureToggles.isFeatureEnabledAsyncAndRedirect('TimeAndBilling', 'InternalComponent');
                        }
                    ]
                }
            });
        }]);
}
